import { InventoryQueryReqDto, inventoryResDto } from '@web/common';
import { authenticatedAPI } from '../AuthenticatedAPI';

export const inventoryData = async (query: InventoryQueryReqDto) => {
  return authenticatedAPI.post(`/api/inventory`, query, inventoryResDto);
};
